const CopyRight = () => {

  return(
    <div className="text-center">
      Copyright &copy; SysLab Technologies 2022
    </div>
  );

};

export default CopyRight;